module.exports = __webpack_public_path__ + "img/apple-icon.e48ba1ab.svg";